import React from 'react';
import PropTypes from 'prop-types';

import './ProgressBar.scss';

export const BAR_THEMES = {
  MOVE: 'Move',
  FILL: 'Fill',
};
export const BAR_COLORS = {
  BLUE: 'blue',
  GREEN: 'green',
};

const ProgressBar = ({ id, time, loop, barColor, className, barTheme }) => {
  const infiniteLoop = loop ? 'infinite' : '1';
  const animationStyle = {
    animationDuration: `${time}s`,
    animationIterationCount: infiniteLoop,
  };
  let statusClass = '';
  if (barTheme === BAR_THEMES.MOVE) {
    statusClass = `progressBar${barTheme}_Status color--${barColor} duration--${time} loop--${infiniteLoop}`;
  } else if (barTheme === BAR_THEMES.FILL) {
    statusClass = `progressBar${barTheme}_Status color--${barColor} duration--${time} loop--${infiniteLoop}`;
  }

  const myId = `progressBar${barTheme}_Status_id_${id}`;
  return (
    <div
      key={`progressBar${barTheme}_${id}`}
      className={`progressBar${barTheme} ${className}`}
    >
      <div className={`progressBar${barTheme}_container`}>
        <div id={myId} style={animationStyle} className={statusClass} />
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  /**
   * {
   *  "info": "Valor que define la el tema de la barra",
   *  "kind": "both",
   *  "beautifulName": "tema de la barra de progreso"
   * }
   */
  barTheme: PropTypes.oneOf([BAR_THEMES.FILL, BAR_THEMES.MOVE]),
  /**
   * {
   *  "info": "Valor que define la duración en segundos de la animación",
   *  "kind": "both",
   *  "beautifulName": "Ancho"
   * }
   */
  time: PropTypes.number,
  /**
   * {
   *  "info": "Valor que define si la animación debe repetirse indefinidamente",
   *  "kind": "both",
   *  "beautifulName": "Ancho"
   * }
   */
  loop: PropTypes.bool,
  /**
   * {
   *  "info": "Valor que define el color de la barra animada",
   *  "kind": "both",
   *  "beautifulName": "Ancho"
   * }
   */
  barColor: PropTypes.oneOf([BAR_COLORS.BLUE, BAR_COLORS.GREEN]),
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: PropTypes.string,
};

ProgressBar.defaultProps = {
  time: 5,
  loop: false,
  barColor: BAR_COLORS.GREEN,
  barTheme: BAR_THEMES.FILL,
  className: '',
};

export default ProgressBar;
